import { render } from "./PackageItem.vue?vue&type=template&id=58f167ea"
import script from "./PackageItem.vue?vue&type=script&lang=js"
export * from "./PackageItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__